import { render } from "./LoginScreen.vue?vue&type=template&id=053c5b3e&scoped=true"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"

import "./LoginScreen.vue?vue&type=style&index=0&id=053c5b3e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Setrin\\dev\\NTS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053c5b3e"]])

export default __exports__